"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withTypeLoop = void 0;
const core_1 = require("@bem-react/core");
const Icon_1 = require("@yandex-lego/components/Icon");
require("./loop.css");
exports.withTypeLoop = (0, core_1.withBemMod)((0, Icon_1.cnIcon)(), {
    type: 'loop'
});
